"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.useStyles = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: {
            display: 'flex',
            zIndex: 0,
            maxHeight: '100vh',
            overflowY: 'hidden',
        },
        menu: function (_a) {
            var menuWidth = _a.menuWidth;
            return ({
                zIndex: 3,
                width: menuWidth,
                position: 'relative',
            });
        },
        slideout: function () { return ({
            zIndex: 2,
            position: 'relative',
        }); },
        content: function (_a) {
            var _b = _a.overflowBehavior, overflowBehavior = _b === void 0 ? 'auto' : _b;
            return ({
                zIndex: 1,
                flexGrow: 1,
                position: 'relative',
                maxHeight: '100vh',
                overflow: overflowBehavior,
                marginLeft: theme.spacing(4),
                marginRight: theme.spacing(4),
            });
        },
    });
});
